<template>
  <div class="com-table balance border">
    <div class="com-title pr">百度留言</div>
    <div class="ms-list">
      <el-row class="operation">
        <el-button-group>
          <el-button type="primary" size="small" :data="search.list" @click="download"><icon name="cloud-download"/>表单线索导出</el-button>
        </el-button-group>
      </el-row>
      <div ref="msSearch"><ms-search :data="search.list" @click="updateConditions"/></div>
      <el-table
        v-loading="table.loading"
        size="small" stripe border
        :data="table.list"
        :fit="true">
        <template slot="empty">
          <no-data></no-data>
        </template>
        <el-table-column prop="feedbackId" label="ID" min-width="60" fixed="left"></el-table-column>
        <el-table-column prop="itemTitle" label="项目名称" min-width="120"></el-table-column>
        <el-table-column prop="channelTitle" label="平台名称" min-width="120"></el-table-column>
        <el-table-column prop="name" label="客户名" min-width="80"></el-table-column>
        <el-table-column prop="phone" label="联系电话" min-width="100"></el-table-column>
        <el-table-column prop="data" label="详细信息" min-width="180">
          <template slot-scope="scope">
            <div v-for="(value,key) in scope.row.datas">
              <span>{{key}}：{{value}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="150"></el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.readStatus === 0" size="small" type="primary" @click="read(scope.$index)">标为已读
            </el-button>
            <el-button v-else size="small" type="success" @click="unRead(scope.$index)">标为未读</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="200">
          <template slot-scope="scope">
            <span>{{scope.row.remark}}</span>
            <span @click="popUs(scope.$index)" style="cursor: pointer">
              <icon name="pencil-square-o"></icon>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="table.pagination.page"
        :total="table.pagination.totalRow"
        :page-size="table.pagination.pageSize"
        :page-sizes="table.pagination.pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
      <el-dialog
        title="修改"
        :visible.sync="dialogVisible"
        width="30%"
        top="15%"
        center
        :before-close="handleClose">
        <el-input
          type="textarea"
          :rows="10"
          v-model="message.remark"
          placeholder="请输入内容">
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="modifierRemrak()">提 交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import MsDetailShow from '@/components/common/FeedbackList'
  import MsSearch from '@/components/common/Search.vue'
  import MsConfirmButton from '@/components/common/ConfirmButton.vue'
  import Api from '@/api/feedback'
  import ResponseParse from '@/utils/response-parse'
  import { FORM_LIST_SEARCH_CONDITION } from '@/models/feedbacks'
  import moment from 'moment'

  export default {
    components: {
      MsDetailShow,
      MsSearch,
      MsConfirmButton
    },
    created () {
      let time = []
      time[0] = moment().format('YYYY-MM-01')
      time[1] = moment().format('YYYY-MM-DD')
      this.search.condition.startTime = time[0]
      this.search.condition.endTime = time[1]
      this.table.loading = true
      this.table.list = []
      this.search.list = FORM_LIST_SEARCH_CONDITION
      this.search.list[0].value = time
      Api.itemTitle(response => {
        let itemTitle = response.data.data
        let title = []
        itemTitle.forEach(value => {
          title.push({value: value.title, label: value.title})
        })
        this.search.list[1].config.list = title
      })
      this.requestList()
    },
    data () {
      return {
        dialogVisible: false,
        search: {
          list: [],
          condition: {}
        },
        table: {
          loading: true,
          list: [],
          pagination: {}
        },
        message: {
          index: 0,
          id: 0,
          remark: ''
        }
      }
    },
    methods: {
      popUs (index) {
        this.dialogVisible = true
        this.message.index = index
        this.message.remark = this.table.list[index].remark
        this.message.id = this.table.list[index].feedbackId
      },
      modifierRemrak () {
        Api.remrakBaiDu({id: this.message.id, remark: this.message.remark}, response => {
          let status = response.status || 0
          if (status >= 200 && status <= 204) {
            let data = this.table.list[this.message.index]
            data.remark = this.message.remark
            this.table.list.splice(this.message.index, 1, data)
            this.dialogVisible = false
            this.$message.success('修改成功')
          } else {
            this.$message.error('修改失败')
          }
        })
      },
      read (index) {
        Api.readBaiDu({id: this.table.list[index].feedbackId}, response => {
          let status = response.status
          if (status >= 200 && status <= 204) {
            let data = this.table.list[index]
            data.readStatus = 1
            // 将原值替换为修改后的值
            this.table.list.splice(index, 1, data)
          }
        })
      },
      unRead (index) {
        Api.unreadBaiDu({id: this.table.list[index].feedbackId}, response => {
          let status = response.status
          if (status >= 200 && status <= 204) {
            let data = this.table.list[index]
            data.readStatus = 0
            // 将原值替换为修改后的值
            this.table.list.splice(index, 1, data)
          }
        })
      },
      requestList () {
        this.table.loading = true
        const search = Object.assign({}, this.table.pagination, this.search.condition, {platformId: 1})
        Api.formList({search: search}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.table.list = body
            let list = []
            this.table.list.forEach(item => {
              if (item.data !== undefined) {
                let d = JSON.parse(item.data)
                if (d !== null) {
                  item.datas = d
                } else {
                  item.datas = []
                }
              } else {
                item.datas = []
              }
              list.push(item)
            })
            this.table.list = list
            this.table.pagination = ResponseParse.pagination(response.headers)
          } else {
            this.table.list = []
          }
          this.table.loading = false
        })
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1
        let time = conditions.time || []
        this.search.condition = Object.assign({}, conditions, {startTime: time[0], endTime: time[1]}, {platformId: 1})
        this.requestList()
      },
      download (conditions) {
        let search = ''
        let flag = true
        this.search.list.forEach(item => {
          let text = item.name
          let value = item.value
          if (item.type === 'select') {
            if (item.hasOwnProperty('config') && item.config.hasOwnProperty('list')) {
              item.config.list.forEach(function (option) {
                if (option.label === item.value) {
                  value = option.value
                }
              })
            }
          }
          if (search === '') {
            if (text === 'time' && value !== '') {
              if (value === null) {
                this.$message({
                  type: 'error',
                  message: '请选择时间范围'
                })
                flag = false
              }
              search = '?startTime=' + value[0] + '&endTime=' + value[1] + '&platformId=1'
            } else {
              if (value !== null && value !== '' && value !== undefined) {
                search = '?' + text + '=' + value
              }
            }
          } else {
            if (text === 'time' && value !== '' && value !== null) {
              if (value === null) {
                this.$message({
                  type: 'error',
                  message: '请选择时间范围'
                })
                flag = false
              }
              search = '&startTime=' + value[0] + '&endTime=' + value[1] + '&platformId=1'
            } else {
              if (value !== null && value !== '' && value !== undefined) {
                search += '&' + text + '=' + value
              }
            }
          }
        })
        if (flag) {
          window.location.href = '/rest/customer/feedback/feedbacks/form-list-file' + search
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .ms-list{
    position: relative;
    .operation{
      position: absolute;
      top:13px;
      right: 0px;
      z-index: 99;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/client/BaiList.vue